// Single source of truth for the dashboard storage version.
// Bumping this busts every visitor's localStorage ONCE at app boot
// (before login), so stale state from older builds can't leak in.
export const DASHBOARD_VERSION = "4.0.0";
